import axios from 'axios';

async function checkWallets(address) {
  if (!address) {
    throw new Error('No address provided');
  }

  await axios.post(
    '/api/cities/check-wallets',
    {
      address,
    },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    }
  );
}

export default checkWallets;
